import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class AdminPaymentMethodUpdateRequest {
  @jsonMember(Boolean)
  public readonly isActive!: boolean;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly description!: string;

  @jsonMember(String)
  public readonly previewFileId?: Nillable<Guid>;

  public constructor(
    private readonly data: {
      description: string;
      isActive: boolean;
      name: string;
      previewFileId?: Nillable<Guid>;
    },
  ) {
    this.description = this.data.description;
    this.isActive = this.data.isActive;
    this.name = this.data.name;
    this.previewFileId = this.data.previewFileId;
  }
}
